import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgXmark = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M18.01 5.99a1.5 1.5 0 0 1 0 2.121L14.121 12l3.89 3.89a1.5 1.5 0 1 1-2.122 2.12L12 14.122l-3.889 3.89a1.5 1.5 0 1 1-2.121-2.122L9.879 12l-3.89-3.889A1.5 1.5 0 1 1 8.112 5.99L12 9.879l3.89-3.89a1.5 1.5 0 0 1 2.12 0'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgXmark)
export default ForwardRef
